import { api } from './client';
import type { FileItem } from '../stores/fileStore';
import type { DocumentType } from '@affogato/shared';

interface GenerateDocumentResponse {
  file: FileItem;
}

export interface GenerateDocumentParams {
  type: DocumentType;
  instructions: string;
  folderId: string | null;
  locale?: string;
}

export const documentsApi = {
  generate: (data: GenerateDocumentParams) =>
    api.post<GenerateDocumentResponse>('/documents/generate', data),
};
